import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'year-month-input',
  props: {
    month: null,
    day: null,
    disabled: { type: [Boolean, null] }
  },
  emits: ["update:month","update:day"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    month: number;
    day: number;
    disabled?: boolean | undefined;
};




const month = ref<any>(props.month || 0)
const day = ref<any>(props.day || 0)
watch([month], () => {
    emits("update:month", month.value)
})
watch([day], () => {
    emits("update:day", day.value)
})

return { __sfc: true,emits, props, month, day }
}

})